export const COMMON_DEBOUNCE_TIME_MS = 300;
export const COMMON_TOAST_DELAY = 50000;
